import React, { useState, useEffect, createContext } from 'react';
import { Navigate, Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Navbar from './Components/Navbar/Navbar';
import CarouselExample from './Components/carousel/carousel';
import AboutUs from './Components/About/AboutUs';
import Mission from './Components/Mission/Mission';
import Courses from './Components/CourseWorkshop/CourseWorkshop';
import LatestNotifications from './Components/Notification/Notification';
import YouTubeFeed from './Components/Youtubefeed/youtubefeed';
import Testimonials from './Components/Testimonial/Testimonial';
import ContactUs from './Components/contact/contact';
import FooterSection from './Components/Footer/FooterSection';
import Footer from './Components/Footer/Footer';
import Sidebar from './Components/Sidebar/sidebar';
import VisionMission from './Pages/VissionMission/VissionMission';
import GetInvolvedPage from './Pages/Donate/Donate';
import Participate from './Pages/Participate/Participate';
import ArrowChat from './Components/Arrowchat/Arrow';
import Gallery from './Pages/Gallery/Gallery';
import Login from './Pages/Login/Login';
import Dashboard from './Dashboard/Dashboard';
import Statistics from './Stastics/Statistics';
import Vision from './Components/Vision/vision';
import ComingSoon from './Pages/comingsoon';
import UpdatedSocialIcons from './Components/Social_Icons/Social_Icons';
import Subscribe from './Components/Subscribe.js/Subscribe';
import TeamPage from './Pages/Team/Team';
import VisionMissionPage from './Pages/VissionMission/VissionMission';

export const AppContext = createContext();

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(localStorage.getItem("isAuthenticated") === "true");
  const navigate = useNavigate();
  const location = useLocation();

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const handleClosePopup = () => {
    setShowPopup(false);
    setIsFirstLoad(false);
    navigate('/');
  };

  const handleDonateClick = () => {
    navigate('/donate');
  };

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
    localStorage.setItem("isAuthenticated", "true");
    navigate('/dashboard'); 
  };

  const isDashboardRoute = location.pathname === '/dashboard';
  const isDonateRoute = location.pathname === '/donate';

  // Show popup after 10 seconds of loading the home page
  useEffect(() => {
    if (isFirstLoad && location.pathname === '/' && !isDonateRoute) {
      const timer = setTimeout(() => {
        setShowPopup(true);
        setIsFirstLoad(false); // Ensure it only shows once
      }, 5000); // 10 seconds delay

      return () => clearTimeout(timer); // Cleanup timeout if user navigates away
    }
  }, [isFirstLoad, isDonateRoute, location.pathname]);

  return (
    <AppContext.Provider value={{ isSidebarOpen, toggleSidebar }}>
      <div>
        {/* Popup */}
        {showPopup && !isDonateRoute && (
          <div className="popup-overlay">
            <div className="popup">
              <button className="close-btn" onClick={handleClosePopup}>
                &times;
              </button>
              <h2 className="popup-heading">
                If you liked our initiative, please get involved with us
              </h2>
              <button className="action-btn" onClick={handleDonateClick}>
                Donate!
              </button>
            </div>
          </div>
        )}

        {/* Conditionally render Navbar, Sidebar, FooterSection, and Footer */}
        {!isDashboardRoute && <Navbar />}
        {!isDashboardRoute && <Sidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />}

        <Routes>
          <Route path="/vision" element={<VisionMissionPage />} />
          <Route path="/donate" element={<GetInvolvedPage />} />
          <Route path="/participate" element={<Participate />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/coming-soon" element={<ComingSoon />} />
          <Route path="/team" element={<TeamPage />} />
          <Route
            path="/dashboard"
            element={
              isAuthenticated ? (
                <Dashboard />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route path="/login" element={<Login onLoginSuccess={handleLoginSuccess} />} />
          <Route path="/subscribe" element={<Subscribe />} />
          <Route path="/" element={
            <div>
              <CarouselExample />
              <div id="about">
                <AboutUs />
              </div>
              <Vision />
              <Mission />
              <Courses />
              <LatestNotifications />
              <YouTubeFeed />
              <Testimonials />
              <Statistics />
              <ContactUs />
            </div>
          } />
        </Routes>

        {!isDashboardRoute && <FooterSection />}
        {!isDashboardRoute && <Footer />}

        <ArrowChat />
        <UpdatedSocialIcons/>
      </div>
    </AppContext.Provider>
  );
}

export default App;
